<template>
  <div>
    <add-co-owner-modal
      :changeCoOwnerInfo="changeCoOwnerInfo"
      :coOwnerDialog="coOwnerDialog"
      :toggleCoOwnerModal="toggleCoOwnerModal"
      :coOwnerInfo="coOwnerInfo"
    />
    <v-dialog v-model="rulesDialog">
      <v-card class="search-modal">
        <h2>Rules</h2>
        <ol class="text-left">
          <li>
            Applicant(s) must have been a Full (Single/Dual/Lifetime) ASCA
            member(s) in good standing for five (5) previous consecutive years.
            Applicant(s) must be 18 years of age or older.
          </li>
          <li>
            Kennel Names registered from 1971 to 1/15/76 are a lifetime issue
            and may not be reassigned except by transfer. There are no further
            kennel renewal fees unless the kennel name is transferred.
          </li>
          <li>
            Kennel Names registered from 1/16/76 to present must be renewed
            every three years. Kennel name will be considered abandoned if
            renewal payment is not postmarked on or before the expiration date.
            The original owner of the kennel name may renew or transfer the
            abandoned kennel name for the first five years following abandonment
            of the kennel name, but after the five years has passed, anyone can
            register the kennel name as their own (effective 1/1/02).
          </li>
          <li>
            All owners or partners of said Kennel Name must sign application for
            Kennel Name to be included on certificate and registry office file
            pertaining to same. Once the Kennel Name is accepted and registered
            with ASCA, no other breeder or owner will be permitted to use the
            Kennel Name or sound alike names without written permission of
            recorded owner(s) of said Kennel Name when the Kennel Name is placed
            at the beginning of a dog's name or at the end when it is preceded
            by the word "of" (1/1/02).
          </li>
          <li>
            Dog's names are limited to thirty (30) letters including spaces,
            punctuation and Kennel Name as stated under Individual Dog
            Registrations. It is suggested that the kennel name not contain the
            words Aussies, Kennels, Farms, etc as the entire kennel name is
            required to be used when naming the dog.
          </li>
          <li>
            A Kennel Name will be recognized only if it is registered with ASCA.
          </li>
          <li>
            A fee will be required to make any deletions, additions, or
            transfers in ownership of a Kennel Name registration.
          </li>
          <li>No variations in spelling or sound-a-likes will be allowed.</li>
          <li>No color used independently will be allowed.</li>
          <li>
            A Kennel Name application and the registration fee must be submitted
            to the ASCA Business Office when either the initial or renewal
            application is made.
          </li>
          <li>
            After 5 renewals, a total of fifteen (15) years, a Kennel Name is
            permanent.
          </li>
          <li>No offensive or profane language will be permitted.</li>
          <li>
            No new Kennel Name may contain the exact name of an existing
            registered kennel.
          </li>
          <li>
            Renewal applications must be submitted by a present member in good
            standing with ASCA.
          </li>
          <li>
            The Business Office will list kennel names in the Aussie Times with
            a notation to send objections and the reason for the objection to
            the Business Office for consideration.
          </li>
          <li>
            Kennel names should not include the words "Aussies, Australian
            Shepherds, Kennels".
          </li>
          <li>
            Kennel name second choice cannot be a pluralized version of the
            first one - i.e. first choice ending with an s or 's.
          </li>
        </ol>
      </v-card>
    </v-dialog>
    <div class="top-icons">
      <router-link class="back-icon" to="/profile/kennels">
        <font-awesome-icon icon="long-arrow-alt-left" size="lg" /> Back to my
        kennels
      </router-link>
    </div>
    <h1 class="register-title">Change Kennel Owners Application</h1>
    <p class="mt-3"><a v-on:click="toggleRules()">View rules</a> <br /></p>
    <v-row justify="center">
      <v-tooltip bottom content-class="fee-table-tooltip">
        <template v-slot:activator="{ on, attrs }">
          <span v-bind="attrs" v-on="on">View pricing table</span>
        </template>
        <simple-fee-table :priceInfo="priceInfo" />
      </v-tooltip>
    </v-row>
    <v-row>
      <v-col>
        <div>
          <h3>
            <strong>Kennel: </strong>{{ selectedKennel.kennelName }} (ID:
            {{ selectedKennel.kennelId }})
          </h3>
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-spacer/>
      <v-col cols="4">
        <div>
          <h3>Current Owners</h3>
          <CoownersList
            :owners="selectedKennel.owners"
            :ownershipType="kennelOwnershipType"
            :hideHeader="true"
          />
        </div>
      </v-col>
      <v-col cols="4">
        <div>
          <h3>
            New Owners&nbsp;&nbsp;<a
              v-if="coOwnerInfo[0]"
              v-on:click="toggleCoOwnerModal()"
              >Edit</a
            >
          </h3>
          <div v-if="coOwnerInfo[0]">
            <v-radio-group v-model="primaryOwner" @change="changePrimaryOwner">
              <span v-for="co in coOwnerInfo" :key="co.personId">
                <span>
                  <v-layout align-start row class="mb-3">
                    <v-radio
                      color="primary"
                      :label="`${co.firstName} ${co.lastName} (Member: ${co.memberId}) `"
                      :value="co.personId"
                    >
                      <template v-slot:label
                        ><span v-if="co.isPrimary">
                          <v-tooltip dark right>
                            <template v-slot:activator="{ on, attrs }">
                              <font-awesome-icon
                                icon="paw"
                                color="primary"
                                v-bind="attrs"
                                v-on="on"
                              />&nbsp;
                            </template>
                            <span
                              >&nbsp;Only the primary owner can request kennel
                              ownership changes. They will also be a primary
                              contact person for the ASCA office.</span
                            >
                          </v-tooltip>
                        </span>
                        <span v-else>
                          <font-awesome-icon icon="paw" color="transparent" />&nbsp;
                        </span>
                        {{ co.firstName }}
                        {{ co.lastName }}
                        <span v-if="co.memberId"
                          >(Member: {{ co.memberId }})</span
                        >
                        <br />
                      </template>
                    </v-radio>
                  </v-layout>
                </span>
              </span>
            </v-radio-group>
          </div>
          <div v-else>
            <a v-on:click="toggleCoOwnerModal()">
              <font-awesome-icon icon="plus" />
              Add co-owner
            </a>
          </div>
        </div>
      </v-col>
      <v-spacer/>
    </v-row>
    <v-btn
      class="white--text"
      large
      v-on:click="changePage(2)"
      :disabled="!selectedKennel.kennelId || !coOwnerInfo.length || primaryOwner === 0"
      color="primary"
      >NEXT</v-btn
    >
    <p class="steps">STEP <b>1</b> OF <b>2</b></p>
    <footer-text />
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import CoownersList, { OwnershipType } from "@/components/common/CoownersList.vue";
import FooterText from "@/components/common/FooterText.vue";
import SimpleFeeTable from "@/components/common/SimpleFeeTable.vue";
import AddCoOwnerModal from "@/components/Portal/AddCoOwnerModal_Kennel.vue";

export default Vue.extend({
  name: "ChangeKennelOwnersForm1",
  data: function () {
    return {
      rulesDialog: false,
      coOwnerDialog: false,
    };
  },
  components: {
    CoownersList,
    AddCoOwnerModal,
    FooterText,
    SimpleFeeTable,
  },
  methods: {
    toggleRules: function () {
      this.$data.rulesDialog = !this.$data.rulesDialog;
    },
    toggleCoOwnerModal: function () {
      this.$data.coOwnerDialog = !this.$data.coOwnerDialog;
    },
  },
  computed: {
    kennelOwnershipType: function () {
      return OwnershipType.Kennel;
    },
  },
  props: {
    selectedKennel: Object,
    changePage: Function,
    searchMemberInfo: Object,
    changeCoOwnerInfo: Function,
    coOwnerInfo: Array,
    primaryOwner: Number,
    changePrimaryOwner: Function,
    priceInfo: Object,
  },
});
</script>
